import React from 'react';
import './Header.css';

const Header = () => {
    return (
          <header>
            <h1>English Premier League</h1>
          </header>
    );
};

export default Header;